import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2, AlertCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ConfirmarAsistenciaPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const accion = searchParams.get('accion');
  
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (token && accion) {
      confirmarAccion();
    } else {
      setLoading(false);
      setError('Link inválido. Faltan parámetros.');
    }
  }, [token, accion]);

  const confirmarAccion = async () => {
    try {
      const response = await axios.post(`${API_URL}/capacitaciones/confirmar-asistencia`, {
        token,
        accion
      });
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al procesar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-emerald-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Procesando tu solicitud...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo-colegio.png" alt="Logo" className="h-12 w-auto" />
          </Link>
        </div>
      </header>

      <main className="max-w-lg mx-auto px-4 py-16">
        <Card className="shadow-lg">
          <CardContent className="pt-8 pb-8 text-center">
            {error ? (
              <>
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <AlertCircle className="w-10 h-10 text-red-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Error</h2>
                <p className="text-gray-600 mb-6">{error}</p>
              </>
            ) : result?.accion === 'confirmada' ? (
              <>
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <CheckCircle className="w-10 h-10 text-emerald-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">¡Asistencia Confirmada!</h2>
                <p className="text-gray-600 mb-6">{result.message}</p>
                <p className="text-sm text-gray-500">Te esperamos en el curso. ¡Gracias por confirmar!</p>
              </>
            ) : result?.accion === 'cancelada' ? (
              <>
                <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <XCircle className="w-10 h-10 text-amber-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Inscripción Cancelada</h2>
                <p className="text-gray-600 mb-6">{result.message}</p>
                <p className="text-sm text-gray-500">Esperamos verte en otra oportunidad.</p>
              </>
            ) : (
              <>
                <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <AlertCircle className="w-10 h-10 text-gray-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Resultado</h2>
                <p className="text-gray-600">{result?.message || 'Operación completada'}</p>
              </>
            )}

            <div className="mt-8">
              <Link to="/capacitaciones">
                <Button variant="outline">
                  Ver más capacitaciones
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
